import { DefaultEnvironment } from './environment.def';

export const environment = Object.assign<DefaultEnvironment, DefaultEnvironment>(new DefaultEnvironment(), {
	production: true,
	systemState: 'Seattle',
	apiUrl: 'https://sys.acadiacraft.com:8443',
	socketUrl: 'https://sys.acadiacraft.com:8442/ws-endpoint',
	systemSeattleUrl: 'https://sys.acadiacraft.com',
	systemCaliforniaUrl: 'https://sys.acadiacraft.com:10443',
  systemCartTvUrl: 'https://sys.acadiacraft.com/cart-tv/'
});
